import { render, staticRenderFns } from "./headertabone.vue?vue&type=template&id=1ec5e6d6&scoped=true&"
import script from "./headertabone.vue?vue&type=script&lang=js&"
export * from "./headertabone.vue?vue&type=script&lang=js&"
import style0 from "./headertabone.vue?vue&type=style&index=0&id=1ec5e6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec5e6d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec5e6d6')) {
      api.createRecord('1ec5e6d6', component.options)
    } else {
      api.reload('1ec5e6d6', component.options)
    }
    module.hot.accept("./headertabone.vue?vue&type=template&id=1ec5e6d6&scoped=true&", function () {
      api.rerender('1ec5e6d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/headertabone.vue"
export default component.exports